class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    FacetFiltersForm.updateColorProduct();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static updateColorProduct(){
  const currentUrl = window.location.href;
  const params = new URLSearchParams(currentUrl);
  const paramsObj = {};
  params.forEach((value, key) => {
      // 如果参数名已经存在，则将新值添加到数组中
      if (paramsObj[key]) {
          // 如果该参数已经是数组，则直接推入新值
          if (Array.isArray(paramsObj[key])) {
              paramsObj[key].push(value);
          } else {
              // 否则，将其转换为数组
              paramsObj[key] = [paramsObj[key], value];
          }
      } else {
          // 如果参数名不存在，直接赋值
          paramsObj[key] = value;
      }
  });
  if(Object.keys(paramsObj).length > 1){
    const colorValues = paramsObj["filter.v.option.color"];
    if(colorValues){
        const sItems = document.querySelectorAll('.s-item');
        sItems.forEach(item => {
          const label = item.querySelector('label');
          if (label) {
              const titleValue = String(label.getAttribute('data-filter-color')).trim();
              if (colorValues.includes(titleValue)) {
                    label.querySelector('.swatch').click();
              }
            }
        });
      } 
  }
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderSizePopup(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderSizePopup(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderSizePopup(html) {
    console.log("renderSizePopup");
    const sizepop = document.querySelector('.coll-size-popup');
    if(sizepop){
      document.querySelector('.coll-size-popup').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.coll-size-popup').innerHTML;
    }   
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
      setTimeout(() => {
        FacetFiltersForm.updateColorProduct();
      }, 500); 
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter,#FacetFiltersFormSize .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter,#FacetFiltersFormSize .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.mobile-facets__sort'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer').bindEvents();
    document.getElementById('FacetFiltersFormSize')?.closest('menu-drawer').bindEvents();

    // Custom Code: 筛选之后，更新移动端弹窗的filter内容
    let openingDrawerFilter = document.querySelector('.mobile-filter-button[aria-expanded="true"]')?.getAttribute('data-stickyfilter');
    let filterOtherElement = document.querySelector(`.quick-filter-overlay__filter-container[data-currentfilter="${openingDrawerFilter}"] .filter-other`);
    let targetElement = html.querySelector(`#FacetsWrapperMobile ${openingDrawerFilter}`);
    if(openingDrawerFilter && filterOtherElement && targetElement) {
      filterOtherElement.innerHTML = targetElement.innerHTML;
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target;
    const sourceFacetsList = source;

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      // const searchParams = this.createSearchParams(event.target.closest('form'));
      // this.onSubmitForm(searchParams, event);

      // 移动端切换filter checkbox时，需要结合sortby当前的值一起筛选
      let forms = [];
      forms.push(this.createSearchParams(event.target.closest('form')));
      sortFilterForms?.forEach((form) => {
        if (form.id === 'FacetFiltersFormMobileSort') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile' || event.target.closest('form').id === 'FacetFiltersFormMobileSort';
      const isSizepopup = event.target.closest('form').id === 'FacetFiltersFormSize'; 

      sortFilterForms.forEach((form) => {
        if (!isMobile && !isSizepopup) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetFiltersFormMobileSort' || form.id === 'FacetFiltersFormSize') {
          forms.push(this.createSearchParams(form));
        } 
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


class ToggleVerticalFilter extends HTMLElement {
  constructor() {
    super();
    const facetButton = this.querySelector('.vertical-filter-button'); 
    facetButton.addEventListener('click', this.onfacetClick.bind(this))
  }
  onfacetClick(event) {
    const summaryElement = event.currentTarget;
    summaryElement.classList.contains('active') ? (summaryElement.classList.remove('active'),summaryElement.setAttribute("aria-expanded", "true")) : (summaryElement.classList.add('active'),summaryElement.setAttribute("aria-expanded", "false"))
    var t = document.querySelector('.vertical-filters-hidden');
    t &&
    t.classList.contains('active') ? (t.classList.add('hidden'),  setTimeout(() => {t.classList.remove('active')}, 5) )  : (t.classList.remove('hidden'), setTimeout(() => {t.classList.add('active')}, 5) )

  }
}

customElements.define('toggle-vertical-filter', ToggleVerticalFilter);

if(!customElements.get('search-type-switchs')) {
  class SearchTypeSwitchs extends HTMLElement {
    constructor() {
      super();
      this.type = '';
      this.typeSwitchs = this.querySelectorAll('.search-type-switchs__item')
    }

    connectedCallback() {
      this.initTypeSwitchs();
      this.initByUrl();
    }
  
    // Init the search-type-switchs event listener
    initTypeSwitchs() {
      this.typeSwitchs?.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          let type = e.target.dataset.type;
          // ADA: control tab active status
          this.typeSwitchs?.forEach((item) => {
            item.classList.remove('active');
            item.setAttribute('aria-selected', 'false');
            item.setAttribute('tabindex', '-1');
          });
          e.target.classList.add('active');
          e.target.setAttribute('aria-selected', 'true');
          e.target.setAttribute('tabindex', '0');
  
          // Handle search-type-switchs click: Update url and fetch new results
          this.handleTypeSwitchs(type, ['q', 'type']);
        });
      });
    }
  
    // Init the search-type-switchs by url params
    initByUrl() {
      let urlParams = new URLSearchParams(window.location.search);
      let type = urlParams.get('type') || 'product';
      if(type) {
        this.typeSwitchs?.forEach((item) => {
          if(item.dataset.type === type) {
            item.classList.add('active');
            item.setAttribute('aria-selected', 'true');
            item.setAttribute('tabindex', '0');
          } else {
            item.classList.remove('active');
            item.setAttribute('aria-selected', 'false');
            item.setAttribute('tabindex', '-1');
          }
        });

        // 如果q和type参数没有变化，则不更新页面内容，只更新filter/sort bar的显示状态
        if(!this.hasQAndTypeUnchanged(document.referrer, window.location.href)){
          this.handleTypeSwitchs(type, ['q', 'type', 'page']);
        } else {
          this.handleFilterToggle(type);
        }
      }
    }
    // Determine whether q and type have unchanged
    hasQAndTypeUnchanged(sourceUrl, currentUrl) {
      if(sourceUrl) {
        let sourceUrlObj = new URL(sourceUrl);
        let currentUrlObj = new URL(currentUrl);
        // 获取源 URL 和当前 URL 的查询参数对象
        let sourceParams = new URLSearchParams(sourceUrlObj.search);
        let currentParams = new URLSearchParams(currentUrlObj.search);
        // 比较 'q' 和 'type' 参数是否一致
        let sourceQ = sourceParams.get('q');
        let currentQ = currentParams.get('q');
        let sourceType = sourceParams.get('type');
        let currentType = currentParams.get('type');
        // 判断 'q' 和 'type' 参数是否都没有变化
        return sourceQ === currentQ && sourceType === currentType;
      } else {
        return false;
      }
    }
    // Handle click event to switch type
    handleTypeSwitchs(type, paramsToKeep) {
      if(this.type !== type) {
        this.type = type;
        // 处理url参数, 只保留paramsToKeep提供的具体参数，其余参数移除
        let url = new URL(window.location.href);
        // 创建一个新的 URLSearchParams 对象
        let newSearchParams = new URLSearchParams();
        // 遍历需要保留的参数，并添加到新的 URLSearchParams 中
        paramsToKeep.forEach(param => {
          if(param === 'type') {
            newSearchParams.set(param, type);
          } else if (url.searchParams.has(param) && param !== 'type') {
            newSearchParams.set(param, url.searchParams.get(param));
          }
        });
        // 更新 URL 的查询参数
        url.search = newSearchParams.toString();
        history.pushState({}, '', url);
        // 异步更新页面内容
        this.fetchAndUpdateResults(url, ['title', '.facets-vertical'], type);
      }
    }
    // Fetch and update results
    fetchAndUpdateResults(url, selectors, type) {
      // Fetch new results
      fetch(url.toString(), {
        credentials: 'same-origin',
        method: 'GET'
      }).then((response) => {
        response.text().then((content) => {
          var tempElement = document.createElement('div');
          var hasResultFlag = true;
          tempElement.innerHTML = content;
          selectors.forEach(selector => {
            if(tempElement.querySelector(`${selector} .product-grid-container`) && tempElement.querySelectorAll(`${selector} [data-type="${type}"] ul li`).length <= 0) {
              document.querySelector(selector).innerHTML = `<p class="no-results-message" role="status" aria-label="No results found for ${type}, please click the category button above to view results.">No results found for ${type}, please click the category tab above to view results.</p>`;
              hasResultFlag = false;
            } else {
              document.querySelector(selector).innerHTML = tempElement.querySelector(selector).innerHTML;
            }
          });

          this.handleFilterToggle(type, hasResultFlag);
          this.initStickyFilterBar();
        });
      });
    }
    // Control Filter Toggle/Sort Bar: Handle sort bar show/hidden
    handleFilterToggle(type, hasResultFlag = true) {
      if(type === 'product' && hasResultFlag) {
        document.querySelector('.facets-vertical-sort')?.classList.remove('hidden');
      } else {
        document.querySelector('.facets-vertical-sort')?.classList.add('hidden');
      }
    }
    // Init sticky filter bar
    initStickyFilterBar() {
      if (window.innerWidth < 749) {
        var selector = {
          mobileFilterbtn: ".mobile-filter-button",
          mobilefilterContainer: ".quick-filter-overlay__filter-container",
          mobilefilterContainerOther: ".quick-filter-overlay__filter-container .filter-other",
          mobilefilterContainerSortby: ".quick-filter-overlay__filter-container .filter-sortby",
          mobilefiltercontainerparent: ".collection-sticky-header__quick-filter-overlay",
          mobilefilteroverlay: ".quick-filter-overlay__filter-out"
        };
        var el_mobileFilterbtn = $(selector.mobileFilterbtn);
        var el_mobilefilterContainer = $(selector.mobilefilterContainer);
        var el_mobilefilterContainerOther = $(selector.mobilefilterContainerOther);
        var el_mobilefilterContainerSortby = $(selector.mobilefilterContainerSortby);
        var el_mobilefiltercontainerparent = $(selector.mobilefiltercontainerparent);
        // sticky option click
        $(document).off("click", selector.mobileFilterbtn).on("click", selector.mobileFilterbtn, function(e) {
          if(e.target.tagName !== 'INPUT') {
            let target = $(this);
            let fitertarget = target.attr("data-stickyfilter");
            let filterCurrentContainer = el_mobilefilterContainer.attr("data-currentfilter");
            
            // 弹窗恢复初始化状态
            el_mobileFilterbtn.attr("aria-expanded", "false");
            el_mobilefilterContainerSortby.addClass("hidden");
            el_mobilefilterContainerOther.html("");
      
            if (fitertarget) {
              if (filterCurrentContainer == "") {
                //初始化 首次点击
                target.attr("aria-expanded", "true");
                fitertarget === '.filter-sortby' ? el_mobilefilterContainerSortby.removeClass("hidden") : el_mobilefilterContainerOther.html($(`#FacetsWrapperMobile ${fitertarget}`).html());
                el_mobilefilterContainer.attr("data-currentfilter", fitertarget);
                el_mobilefiltercontainerparent.removeClass("hidden");
              } else {
                if (filterCurrentContainer != fitertarget) {
                  target.attr("aria-expanded", "true");
                  //从一个按钮 再点到另外一个按钮 换按钮的时候，只有内容更新
                  fitertarget === '.filter-sortby' ? el_mobilefilterContainerSortby.removeClass("hidden") : el_mobilefilterContainerOther.html($(`#FacetsWrapperMobile ${fitertarget}`).html());
                  el_mobilefilterContainer.attr("data-currentfilter", fitertarget);
                  el_mobilefiltercontainerparent.removeClass("hidden");
                } else {
                  //从一个按钮 再点同一个按钮,内容关闭
                  target.attr("aria-expanded", "false");
                  el_mobilefilterContainerSortby.addClass("hidden");
                  el_mobilefilterContainerOther.html("");
                  el_mobilefilterContainer.attr("data-currentfilter", "");
                  el_mobilefiltercontainerparent.addClass("hidden");
                }
              }
            } else {
              el_mobileFilterbtn.attr("aria-expanded", "false");
              el_mobilefilterContainerSortby.addClass("hidden");
              el_mobilefilterContainerOther.html("");
              el_mobilefilterContainer.attr("data-currentfilter", "");
              el_mobilefiltercontainerparent.addClass("hidden");
            }
          }
        });
        $(document).on("keydown", selector.mobileFilterbtn, function() {
          if (e.key == "Enter" || e.key == "") {
            $(this).click();
          }
        });
        // overlay control
        $(document).on("click", selector.mobilefilteroverlay, function() {
          el_mobileFilterbtn.attr("aria-expanded", "false");
          el_mobilefilterContainerSortby.addClass("hidden");
          el_mobilefilterContainerOther.html("");
          el_mobilefilterContainer.attr("data-currentfilter", "");
          el_mobilefiltercontainerparent.addClass("hidden");
        });
        // Clear button event
        $(document).on("click", '.filters-clear-btn', function(e) {
          e.preventDefault();
          e.stopPropagation();
          let currentFilter = $(this).parents(selector.mobilefilterContainer).attr("data-currentfilter");
          let t = $(`#FacetsWrapperMobile ${currentFilter}`).find("input:checked");
          t.click();
          $(this).addClass("hidden");
        });
        $(document).on("keydown", '.filters-clear-btn', function(e) {
          if(e.key == 'Enter' || e.key == '') {
            $(this).click();
          }
        });
        // Apply button event
        $(document).on("click", '.filters-apply-btn', function(e) {
          e.preventDefault();
          e.stopPropagation();
          //sticky header hide start
          el_mobileFilterbtn.attr("aria-expanded", "false");
          el_mobilefilterContainerSortby.addClass("hidden");
          el_mobilefilterContainerOther.html("");
          el_mobilefilterContainer.attr("data-currentfilter", "");
          el_mobilefiltercontainerparent.addClass("hidden");//sticky header hide end
        });
        $(document).on("keydown", '.filters-apply-btn', function(e) {
          if(e.key == 'Enter' || e.key == '') {
            $(this).click();
          }
        });
        
        // Scroll to sticky
        var p=0, t=0;
        var filterStickyHeader = $(".collection-sticky-header");
        var globalTopBar = $(".announcement-bar-section .utility-bar__grid");
        var globalHeader = $(".section-header");
        var stickyheaderTop = filterStickyHeader.offset().top;
        var init_header_height = globalHeader.height();
        var init_topbar_height = globalTopBar.height();
        var init_stickheader = stickyheaderTop - init_topbar_height - init_header_height;
        $(window).scroll(function() {
          p = $(this).scrollTop();
          if(p == init_header_height){
            globalTopBar.removeClass("hidden").css("height", init_topbar_height);     
          }
          if(t<p){//down
            globalTopBar.addClass("hidden").css("height", 0);
            globalHeader.css("top", 0);
          }else{//up
            globalTopBar.removeClass("hidden").css("height", init_topbar_height);
            globalHeader.css("top", init_topbar_height);
          }
          let header_height = globalTopBar.height() + globalHeader.height();
          if (p > init_stickheader) {
            filterStickyHeader.addClass("is-sticky").css("top", header_height);
          } else {
            filterStickyHeader.removeClass("is-sticky").css("top", '0');
          }
          setTimeout(function(){ t = p; }, 5000);
        });
      }
    }
  }
  customElements.define('search-type-switchs', SearchTypeSwitchs);
}

document.addEventListener('DOMContentLoaded', () => {
  const facetsLists = document.querySelectorAll('.facets-layout-list');
  facetsLists.forEach(facetsList => {
      const hasHTML = facetsList.innerHTML.trim() !== '';
      if (!hasHTML) {
          const summaryElement = facetsList.closest('details'); 
          if (summaryElement) {
              summaryElement.style.display = 'none'; 
          }
      }
  });

  // sticky header
  if (window.innerWidth < 749) {
    var selector = {
      mobileFilterbtn: ".mobile-filter-button",
      mobilefilterContainer: ".quick-filter-overlay__filter-container",
      mobilefilterContainerOther: ".quick-filter-overlay__filter-container .filter-other",
      mobilefilterContainerSortby: ".quick-filter-overlay__filter-container .filter-sortby",
      mobilefiltercontainerparent: ".collection-sticky-header__quick-filter-overlay",
      mobilefilteroverlay: ".quick-filter-overlay__filter-out"
    };
    var el_mobileFilterbtn = $(selector.mobileFilterbtn);
    var el_mobilefilterContainer = $(selector.mobilefilterContainer);
    var el_mobilefilterContainerOther = $(selector.mobilefilterContainerOther);
    var el_mobilefilterContainerSortby = $(selector.mobilefilterContainerSortby);
    var el_mobilefiltercontainerparent = $(selector.mobilefiltercontainerparent);
    // sticky option click
    $(document).off("click", selector.mobileFilterbtn).on("click", selector.mobileFilterbtn, function(e) {
      if(e.target.tagName !== 'INPUT') {
        let target = $(this);
        let fitertarget = target.attr("data-stickyfilter");
        let filterCurrentContainer = el_mobilefilterContainer.attr("data-currentfilter");
        
        // 弹窗恢复初始化状态
        el_mobileFilterbtn.attr("aria-expanded", "false");
        el_mobilefilterContainerSortby.addClass("hidden");
        el_mobilefilterContainerOther.html("");
  
        if (fitertarget) {
          if (filterCurrentContainer == "") {
            //初始化 首次点击
            target.attr("aria-expanded", "true");
            fitertarget === '.filter-sortby' ? el_mobilefilterContainerSortby.removeClass("hidden") : el_mobilefilterContainerOther.html($(`#FacetsWrapperMobile ${fitertarget}`).html());
            el_mobilefilterContainer.attr("data-currentfilter", fitertarget);
            el_mobilefiltercontainerparent.removeClass("hidden");
          } else {
            if (filterCurrentContainer != fitertarget) {
              target.attr("aria-expanded", "true");
              //从一个按钮 再点到另外一个按钮 换按钮的时候，只有内容更新
              fitertarget === '.filter-sortby' ? el_mobilefilterContainerSortby.removeClass("hidden") : el_mobilefilterContainerOther.html($(`#FacetsWrapperMobile ${fitertarget}`).html());
              el_mobilefilterContainer.attr("data-currentfilter", fitertarget);
              el_mobilefiltercontainerparent.removeClass("hidden");
            } else {
              //从一个按钮 再点同一个按钮,内容关闭
              target.attr("aria-expanded", "false");
              el_mobilefilterContainerSortby.addClass("hidden");
              el_mobilefilterContainerOther.html("");
              el_mobilefilterContainer.attr("data-currentfilter", "");
              el_mobilefiltercontainerparent.addClass("hidden");
            }
          }
        } else {
          el_mobileFilterbtn.attr("aria-expanded", "false");
          el_mobilefilterContainerSortby.addClass("hidden");
          el_mobilefilterContainerOther.html("");
          el_mobilefilterContainer.attr("data-currentfilter", "");
          el_mobilefiltercontainerparent.addClass("hidden");
        }
      }
    });
    $(document).on("keydown", selector.mobileFilterbtn, function() {
      if (e.key == "Enter" || e.key == "") {
        $(this).click();
      }
    });
    // overlay control
    $(document).on("click", selector.mobilefilteroverlay, function() {
      el_mobileFilterbtn.attr("aria-expanded", "false");
      el_mobilefilterContainerSortby.addClass("hidden");
      el_mobilefilterContainerOther.html("");
      el_mobilefilterContainer.attr("data-currentfilter", "");
      el_mobilefiltercontainerparent.addClass("hidden");
    });
    // Clear button event
    $(document).on("click", '.filters-clear-btn', function(e) {
      e.preventDefault();
      e.stopPropagation();
      let currentFilter = $(this).parents(selector.mobilefilterContainer).attr("data-currentfilter");
      let t = $(`#FacetsWrapperMobile ${currentFilter}`).find("input:checked");
      t.click();
      $(this).addClass("hidden");
    });
    $(document).on("keydown", '.filters-clear-btn', function(e) {
      if(e.key == 'Enter' || e.key == '') {
        $(this).click();
      }
    });
    // Apply button event
    $(document).on("click", '.filters-apply-btn', function(e) {
      e.preventDefault();
      e.stopPropagation();
      //sticky header hide start
      el_mobileFilterbtn.attr("aria-expanded", "false");
      el_mobilefilterContainerSortby.addClass("hidden");
      el_mobilefilterContainerOther.html("");
      el_mobilefilterContainer.attr("data-currentfilter", "");
      el_mobilefiltercontainerparent.addClass("hidden");//sticky header hide end
    });
    $(document).on("keydown", '.filters-apply-btn', function(e) {
      if(e.key == 'Enter' || e.key == '') {
        $(this).click();
      }
    });
    
    // Scroll to sticky
    var p=0, t=0;
    var filterStickyHeader = $(".collection-sticky-header");
    var globalTopBar = $(".announcement-bar-section .utility-bar__grid");
    var globalHeader = $(".section-header");
    var stickyheaderTop = filterStickyHeader.offset().top;
    var init_header_height = globalHeader.height();
    var init_topbar_height = globalTopBar.height();
    var init_stickheader = stickyheaderTop - init_topbar_height - init_header_height;
    $(window).scroll(function() {
      p = $(this).scrollTop();
      if(p == init_header_height){
        globalTopBar.removeClass("hidden").css("height", init_topbar_height);     
      }
      if(t<p){//down
        globalTopBar.addClass("hidden").css("height", 0);
        globalHeader.css("top", 0);
      }else{//up
        globalTopBar.removeClass("hidden").css("height", init_topbar_height);
        globalHeader.css("top", init_topbar_height);
      }
      let header_height = globalTopBar.height() + globalHeader.height();
      if (p > init_stickheader) {
        filterStickyHeader.addClass("is-sticky").css("top", header_height);
      } else {
        filterStickyHeader.removeClass("is-sticky").css("top", '0');
      }
      setTimeout(function(){ t = p; }, 5000);
    });
  }
});